module.exports = __webpack_public_path__ + "cf2bc25d04170bfd923f5b1131bbfb86.svg";